/* tslint:disable */
/* eslint-disable */
/**
 * noco-server
 * noco-server
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { UpdateDocumentShareByLinkRequestDocumentShareFromJSON, UpdateDocumentShareByLinkRequestDocumentShareToJSON } from './UpdateDocumentShareByLinkRequestDocumentShare';
export function UpdateDocumentShareByLinkRequestFromJSON(json) {
    return UpdateDocumentShareByLinkRequestFromJSONTyped(json, false);
}
export function UpdateDocumentShareByLinkRequestFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) {
        return json;
    }
    return {
        documentShare: !exists(json, 'document_share')
            ? undefined
            : UpdateDocumentShareByLinkRequestDocumentShareFromJSON(json['document_share'])
    };
}
export function UpdateDocumentShareByLinkRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        document_share: UpdateDocumentShareByLinkRequestDocumentShareToJSON(value.documentShare)
    };
}
